import { createReducer, on } from '@ngrx/store';
import * as DeliveryScheduleActions from './delivery-schedule.actions';
import { LoadsAgenda } from 'src/app/pages/orders/delivery-schedule/components/graph-delivery-schedule/models/graph-delivery-schedule.model';

export interface DeliveryScheduleState {
  response: LoadsAgenda | null;
  error: any | null;
  loading: boolean;
  cache?: { [key: string]: LoadsAgenda };
}

export const initialState: DeliveryScheduleState = {
  response: null,
  error: null,
  loading: false,
  cache: {},
};

export const deliveryScheduleReducer = createReducer(
  initialState,
  on(DeliveryScheduleActions.loadDeliverySchedule, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(DeliveryScheduleActions.loadDeliveryScheduleSuccessByKey, (state, { key, response }) => ({
    ...state,
    loading: false,
    response,
    cache: { ...(state.cache || {}), [key]: response },
    error: null,
  })),
  on(DeliveryScheduleActions.loadDeliveryScheduleFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(DeliveryScheduleActions.resetDeliveryScheduleState, () => ({
    ...initialState,
  })),
);
